import classNames from 'classnames'
import { PropsWithChildren } from 'react'
import NextLink, { LinkProps as NextLinkProps } from 'next/link'
import styles from './Link.module.scss'

export interface LinkProps extends NextLinkProps {
  id?: string
  className?: string
  target?: string
}

const Link = (props: PropsWithChildren<LinkProps>) => {
  const { children, className, ...rest } = props

  const linkClassName = classNames(className, styles.link)

  return (
    <NextLink className={linkClassName} {...rest}>
      {children}
    </NextLink>
  )
}

export default Link
